// extracted by mini-css-extract-plugin
module.exports = {"comp":"PowerSolution_comp__J754W","ani-fade-in-opacity":"PowerSolution_ani-fade-in-opacity__9261b","ani-fade-in-width":"PowerSolution_ani-fade-in-width__HSn_m"};